module.exports = __webpack_public_path__ + "static/media/stopRecordingWave.910ee55a.jpg";